import React from "react";
import { Col, Container, Row } from "reactstrap";
import { Link } from "react-router-dom";

const LINK_CLASS = "design-section__timeline-link";

// Milestones, newest year first. Within a year, entries alternate sides of the
// centre line starting on the left, so adding or removing one just shifts the
// rest -- no markup to hand-edit.
const MILESTONES = [
  {
    year: 2026,
    events: [
      "Mapping in Sweden begins.",
      "Mapping in China begins.",
      "Mapping in Australia begins.",
      "Mapping in Mexico begins.",
      "3,200 golf courses mapped in the U.K.",
      "Mapping in the U.K. begins.",
      "1,500 golf courses mapped in Canada.",
    ],
  },
  {
    year: 2025,
    events: [
      "Mapping in Canada begins.",
      "17,000 golf courses mapped. Majority of United States courses complete!",
    ],
  },
  {
    year: 2024,
    events: [
      "14,000 golf courses mapped.",
      "Website redeveloped to focus on features for API customers. Sadly, golfer tools platform is terminated.",
      "Mapping volume increased to 200 courses per month.",
    ],
  },
  {
    year: 2023,
    events: [
      "Database closes in on most 18-hole courses.",
      "Mapping volume increased to 100 courses per month.",
      "Golfbert Mapping Team increased again to keep up with demand.",
    ],
  },
  {
    year: 2020,
    events: ["Golf course mapping continues weekly!"],
  },
  {
    year: 2019,
    events: [
      "8,000 golf courses mapped.",
      "Golfbert Mapping Team increased to keep up with demand.",
    ],
  },
  {
    year: 2018,
    events: ["Single course API released."],
  },
  {
    year: 2017,
    events: [
      <>
        API V1 released to all customers at
        <Link to="/api/overview" className={LINK_CLASS}>
          {" "}
          golfbert.com/api.
        </Link>
      </>,
      "Search API released.",
      "API V1 released to BETA customers.",
      <>
        API documentation and guides released at
        <Link to="/api/documentations" className={LINK_CLASS}>
          {" "}
          golfbert.com/api/docs.
        </Link>
      </>,
      "API production begins. Allows other golf developers access to Golfbert's golf course geodata and course information.",
    ],
  },
  {
    year: 2016,
    events: ["7,000 golf courses mapped."],
  },
  {
    year: 2015,
    events: [
      <>
        Golfer tools interface redesigned at
        <Link to="/landing" className={LINK_CLASS}>
          {" "}
          golfbert.com.
        </Link>
      </>,
      <>
        Responsive site design established at
        <Link to="/landing" className={LINK_CLASS}>
          {" "}
          golfbert.com
        </Link>{" "}
        to enhance mobile experience.
      </>,
      <>
        Golf course database redesigned at
        <Link to="/landing" className={LINK_CLASS}>
          {" "}
          golfbert.com.
        </Link>
      </>,
      "In-app golfer stat tracking added to CaddyTracker for iOS.",
    ],
  },
  {
    year: 2014,
    events: [
      "QuickPlay added to CaddyTracker for iOS.",
      "CaddyTracker for iOS V3 launches.",
      "5,000 golf courses mapped.",
    ],
  },
  {
    year: 2013,
    events: [
      "Interactive stats charts added to golfer tools.",
      "3,500 golf courses mapped.",
    ],
  },
  {
    year: 2012,
    events: [
      "CaddyTracker for iOS V2 launches.",
      "2,500 golf courses mapped.",
      "Private groups added to golfer tools.",
    ],
  },
  {
    year: 2011,
    events: [
      "1,000 golf courses mapped.",
      "AppSync added to golfer tools. Allows automatic syncing of golfer rounds from iOS app with profiles at golfbert.com.",
    ],
  },
  {
    year: 2010,
    events: [
      "CaddyTracker for iOS V1 launches.",
      "Caddytracker GPS golfer app for iOS production begins.",
      "First 100 golf courses mapped.",
      "Golf course hole maps added to golfbert.com database.",
    ],
  },
  {
    year: 2009,
    events: [
      "Golf course mapping begins.",
      "Golf course mapping engine established.",
      "Golf course database V1 launched at golfbert.com. Basic course information on 15,000+ golf courses in the United States.",
    ],
  },
];

// Each entry fills one row of the 3-column grid (content / centre line /
// content). Left-hand entries are preceded by an empty row so the centre line
// keeps running between the dots.
const TimelineEntry = ({ side, children }) =>
  side === "left" ? (
    <>
      <div className="timeline-empty"></div>
      <div className="timeline-middle"></div>
      <div className="timeline-component timeline-content"></div>

      <div className="timeline-component timeline-content">
        <p className="text-right">{children}</p>
      </div>
      <div className="timeline-middle">
        <div className="timeline-circle"></div>
      </div>
      <div className="timeline-empty"></div>
    </>
  ) : (
    <>
      <div className="timeline-empty"></div>
      <div className="timeline-middle">
        <div className="timeline-circle"></div>
      </div>
      <div className="timeline-component timeline-content">
        <p>{children}</p>
      </div>
    </>
  );

const Timeline = () => {
  return (
    <div className="timeline">
      <div className="timeline__first-sec">
        <Container>
          <Row>
            <Col md="12" className="text-center">
              <h3>Timeline</h3>
              <p>
                We're bringing the world's best golf course geodata directly to
                you. We've successfully mapped the majority of the United States
                and are now expanding globally! Active mapping is currently
                underway in Canada, Mexico, the U.K., Australia, Sweden, and
                China, with full worldwide coverage coming soon.
              </p>
            </Col>
          </Row>
        </Container>
      </div>

      <Container>
        <Row className="design-section">
          {MILESTONES.map(({ year, events }) => (
            <React.Fragment key={year}>
              <span className="design-section__mid-year text-center text-muted">
                {year}
              </span>
              <div className="design-section__timeline-sec">
                {events.map((event, index) => (
                  <TimelineEntry
                    key={`${year}-${index}`}
                    side={index % 2 === 0 ? "left" : "right"}
                  >
                    {event}
                  </TimelineEntry>
                ))}
              </div>
            </React.Fragment>
          ))}
        </Row>
      </Container>
    </div>
  );
};

export default Timeline;
